define([
	"dojo/_base/declare",
	"csi/heading/AggregateController",
	"csi/page",
	"csi/view",
	"csi/widget/MessageDialog",
	"csi/xml"
], function(declare,AggregateController,page,csiView,MessageDialog,xml) {

	return declare(AggregateController, {
		bHold: false,

		confirmAction: function(/*Object*/params) {
			//summary: customize buttons
			params.materialIcon = MessageDialog.ICON_WARNING;
			params.buttons = [MessageDialog.BUTTON_CHANGE_TEMPLATE + MessageDialog.BUTTON_PRIMARY, MessageDialog.BUTTON_CANCEL];
			this.inherited(arguments);
		},
					
		onConfirm: function(/*String*/key) {
			// summary: if configured to confirm action, then start now that confirmed
			if (key == MessageDialog.BUTTON_CHANGE_TEMPLATE) {
				AggregateController.prototype.publish.call(this);
			} else {
				this.postProcess();
			}
		},

		publish: function() {
			// summary: confirm action if it will change the line items
			if (this._changesLineItems()) {
				this.confirmAction({});
			} else {
				this.inherited(arguments);
			}
		},

		postProcessSuccess: function() {
			// summary: if we changed the line items, refresh the line-items table
			this.inherited(arguments);

			if (this._changesLineItems()) {
				var v = csiView.getView("StyleLineItems") || csiView.getView("MaterialLineItems");
				if (v) {
					v.redrawData();
				}
			}
		},

		_changesLineItems: function() {
			// summary: return true if a new template was selected and there are line items that are affected
			return xml.isValidURL(this.newValue) && this.getNode().LineItems.length;
		}
	});
});
